export type FieldProcessor = (fieldName: string, fieldValue: string) => void;
export class FilterDataManagerComponent {
    private formName: string;
    private fieldProcessor: FieldProcessor;

    constructor(formName: string, fieldProcessor: FieldProcessor) {
        this.formName = formName;
        this.fieldProcessor = fieldProcessor;
    }

    loadRetainedFilter() {
        const storedFormDataString = localStorage.getItem(this.formName);

        if (storedFormDataString) {
            const storedFormData: { name: string; value: string }[] = JSON.parse(storedFormDataString);

            storedFormData.forEach((field) => {
                const inputElement = document.querySelector(`[name="${field.name}"]`) as HTMLElement | null;

                if (inputElement) {
                    if (inputElement instanceof HTMLInputElement) {
                        if (inputElement.type === 'checkbox' || inputElement.type === 'radio') {
                            inputElement.checked = inputElement.value === field.value;
                        } else {
                            inputElement.value = field.value;
                        }
                    } else if (inputElement instanceof HTMLSelectElement) {
                        inputElement.value = field.value;
                    } else if (inputElement instanceof HTMLTextAreaElement) {
                        inputElement.value = field.value;
                    }

                    this.fieldProcessor(field.name, field.value);
                }
            });
        }
    }

    saveFormData() {
        const formData: { name: string; value: string }[] = [];
        const formElements = document.querySelectorAll(`[name]`);

        formElements.forEach((element) => {
            if (element instanceof HTMLInputElement || element instanceof HTMLSelectElement || element instanceof HTMLTextAreaElement) {
                formData.push({ name: element.name, value: element.value });
            }
        });

        localStorage.setItem(this.formName, JSON.stringify(formData));
    }
}
